var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveChartSize1X1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 3.5,
    fill: "#666666",
    stroke: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 3.5,
    fill: "white",
    stroke: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 26.5,
    width: 21,
    height: 21,
    rx: 3.5,
    fill: "white",
    stroke: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 26.5,
    width: 21,
    height: 21,
    rx: 3.5,
    fill: "white",
    stroke: "#9E9E9E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.364 59.812V61H12.78V59.812H14.484V55.624C14.412 55.72 14.3 55.82 14.148 55.924C13.996 56.028 13.824 56.128 13.632 56.224C13.448 56.312 13.26 56.384 13.068 56.44C12.876 56.496 12.7 56.524 12.54 56.524V55.288C12.7 55.288 12.884 55.24 13.092 55.144C13.3 55.048 13.504 54.936 13.704 54.808C13.912 54.672 14.088 54.544 14.232 54.424C14.376 54.296 14.46 54.204 14.484 54.148H15.84V59.812H17.364ZM22.1493 54.724L23.6373 56.872L23.7453 57.076L23.8533 56.872L25.3293 54.724H26.7573L24.5013 57.868L26.7813 61H25.3533L23.8533 58.864L23.7453 58.672L23.6373 58.864L22.1373 61H20.7093L22.9893 57.88L20.7333 54.724H22.1493ZM35.2117 59.812V61H30.6277V59.812H32.3317V55.624C32.2597 55.72 32.1477 55.82 31.9957 55.924C31.8437 56.028 31.6717 56.128 31.4797 56.224C31.2957 56.312 31.1077 56.384 30.9157 56.44C30.7237 56.496 30.5477 56.524 30.3877 56.524V55.288C30.5477 55.288 30.7317 55.24 30.9397 55.144C31.1477 55.048 31.3517 54.936 31.5517 54.808C31.7597 54.672 31.9357 54.544 32.0797 54.424C32.2237 54.296 32.3077 54.204 32.3317 54.148H33.6877V59.812H35.2117Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveChartSize1X1);
export default __webpack_public_path__ + "static/media/inactiveChartSize1x1.14a7dc4257ff7f13a4b578656abab6b1.svg";
export { ForwardRef as ReactComponent };